import moment from "moment-timezone";
import {useTranslation} from "@i18n/client";

import {I18nNamespace} from "@i18n";

export default function useTodayTomorrowString(
  apptTime: moment.Moment,
  currentTime: moment.Moment,
) {
  const i18n = useTranslation(I18nNamespace.WEB_SCHEDULING);
  if (currentTime.isSame(apptTime, "day")) {
    return i18n.t("Today, {{apptDate}} at {{apptTime}}", {
      ns: "web-scheduling",
      apptDate: apptTime.format("MMMM Do"),
      apptTime: apptTime.format("h:mma"),
    });
  }
  const nextDay = apptTime.clone().add(1, "day");
  if (currentTime.isSame(nextDay, "day")) {
    return i18n.t("Tomorrow, {{apptDate}} at {{apptTime}}", {
      ns: "web-scheduling",
      apptDate: apptTime.format("MMMM Do"),
      apptTime: apptTime.format("h:mma"),
    });
  }
  return i18n.t("{{day}}, {{apptDate}} at {{apptTime}}", {
    ns: "web-scheduling",
    day: apptTime.format("dddd"),
    apptDate: apptTime.format("MMMM Do"),
    apptTime: apptTime.format("h:mma"),
  });
}
